import React from 'react';
import { CTAButton } from './CTAButton';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function FinalCTA() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section id="final-cta" ref={ref} className={`relative w-full py-10 md:py-12 lg:py-20 px-6 md:px-12 lg:px-20 bg-gradient-to-b from-brand-navy to-brand-teal text-white scroll-animate ${isVisible ? 'visible' : ''}`} data-id="element-22">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-85" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1544776193-352d25ca82cd?w=1600&q=80")'
    }} aria-hidden="true" data-id="element-23">
        <div className="absolute inset-0 bg-brand-navy/85" data-id="element-24" />
      </div>

      <div className="relative z-10 max-w-[800px] mx-auto text-center" data-id="element-25">
        <h2 className="text-[26px] md:text-[32px] lg:text-[40px] font-bold text-white leading-[1.3] tracking-[-0.3px] mb-4" data-id="element-26">
          Get TUBO™ at 20% Off Today
        </h2>

        <p className="text-[16px] md:text-[18px] lg:text-[20px] font-medium text-[#E8E8E8] leading-[1.5] mb-12" data-id="element-27">
          <strong data-id="element-28">Transform</strong> Your Child's Bath Time in 14 Days.{' '}
          <strong data-id="element-29">Guaranteed.</strong>
        </p>

        <div className="flex justify-center mb-8" data-id="element-30">
          <CTAButton variant="primary" data-id="element-31">
            Get TUBO™ at 20% Off (Today Only)
          </CTAButton>
        </div>

        <div className="text-[14px] text-[#A0A0A0] my-6 text-center" data-id="element-32">or</div>

        {/* What You Get */}
        <div className="mt-8" data-id="element-33">
          <h3 className="text-[16px] md:text-[18px] lg:text-[20px] font-bold text-white mb-4 text-center" data-id="element-34">
            What You Get:
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-[800px] mx-auto text-left" data-id="element-35">
            {['TUBO™ Filtered Showerhead with 20-stage filtration', 'Tool-free installation (fits all standard Australian showerheads)', "60-day money-back guarantee (no questions, full refund if you don't see results)", 'Lifetime warranty option (available at checkout)', 'Filter replacement cartridges ($15-20 every 6-8 months)', 'Email support & installation video'].map((item, i) => <div key={i} className="bg-white/10 border border-white/15 rounded-md p-4 flex items-start gap-3" data-id="element-36">
                <span className="text-brand-orange font-bold text-[16px] mt-0.5" data-id="element-37">
                  ✓
                </span>
                <span className="text-[15px] text-white font-medium leading-[1.6]" data-id="element-38">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Guarantee Box */}
        <div className="bg-brand-gold/15 border-2 border-brand-gold rounded-lg p-5 md:p-7 lg:p-7 my-10 shadow-[0_4px_16px_rgba(212,165,116,0.2)] text-left" data-id="element-39">
          <h3 className="text-[16px] md:text-[18px] lg:text-[20px] font-bold text-white mb-3" data-id="element-40">
            The Guarantee That Removes Risk
          </h3>
          <p className="text-[16px] text-white font-normal leading-[1.8] m-0" data-id="element-41">
            We're <strong data-id="element-42">confident enough</strong> in the mechanism that we
            offer a 60-day guarantee. Install it, use it for two weeks, and if
            you don't see
            <strong data-id="element-43"> noticeable difference</strong> in your child's skin comfort
            and behavior around bath time, you get{' '}
            <strong data-id="element-44">every cent back</strong>. You're not risking anything except
            trying something other parents have{' '}
            <strong data-id="element-45">already discovered works</strong>.
          </p>
        </div>

        {/* Secondary CTAs */}
        <div className="flex flex-col items-center gap-3" data-id="element-46">
          <CTAButton variant="secondary" className="w-full md:w-auto" data-id="element-47">
            See the Mechanism in Action (Video Explanation)
          </CTAButton>
          <CTAButton variant="tertiary" className="w-full md:w-auto mt-3" data-id="element-48">
            Read Stories from 10,000+ Australian Parents Who Addressed This
          </CTAButton>
        </div>

        {/* Reassurance */}
        <div className="mt-10 p-6 bg-brand-teal/10 border-l-4 border-brand-teal rounded text-center" data-id="element-49">
          <p className="text-[15px] text-white font-medium leading-[1.8] m-0" data-id="element-50">
            Most parents report seeing{' '}
            <strong data-id="element-51">change within 7-10 showers</strong>. By week 2-3, the
            behavioral shifts (<strong data-id="element-52">reduced fear</strong> of bath time,{' '}
            <strong data-id="element-53">increased confidence</strong>) become apparent. By week 4,
            you're wondering{' '}
            <strong data-id="element-54">why you didn't know about this sooner</strong>.
          </p>
        </div>
      </div>
    </section>;
}